import { Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { ValidationService } from '../../../shared/providers/validation.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { IPendingMyPortfolioProperties } from '../../../shared/models/PendingMyPortfolioProperties';
import { DataTableDirective } from 'angular-datatables';
import { OfferService } from '../../../shared/providers/offer.service';
import { Input } from '@angular/core';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-pending-portfolio-properties',
  templateUrl: './pending-portfolio-properties.component.html',
  styleUrls: ['./pending-portfolio-properties.component.css']
})
export class PendingPortfolioProperties implements OnInit,OnDestroy {
  currentMenu = '';
  constructor(private offerService: OfferService, public Validation: ValidationService, public authentication: AuthenticationService) {
  }
  private _subscriptions: Subscription;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  user: any;
  pendingProperties: IPendingMyPortfolioProperties[] = [];
  currentUser: any;
  @Input() UserGuid: string = '0000';
  @Input() IsmyPortfolio: boolean = true;
  @Input() PortfolioName: string;

  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
    this.user = this.authentication.user;
    this.getPendingProperties();
  }

  // to fetch the offer accepted or undercontracted properties
  async getPendingProperties() {
    this._subscriptions = await this.offerService.getPendingPortfolioProperties(this.user.Id, this.UserGuid).subscribe(response => {
      this.pendingProperties = response;
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
